import { Tabs } from '@mantine/core';
import React, { memo, useEffect, useState } from 'react';
import classes from './ManageProductsCategory.module.css';
import useFetch from '../../../Customhooks/useFetch';
import { baseUrl } from '../../../Constants/constant';
import TableCategoryComponent from './TableCategory.component';

const Categorydatatable = ({editLink, search}:any) => {
  const [activeTab, setActiveTab] = useState<string | null>('0');
  // Track which tabs have been visited to control rendering
  const [visitedTabs, setVisitedTabs] = useState<Set<string>>(new Set(['0']));

  const token = localStorage.getItem("token");

  const {
    data: datalist,
    loading: listLoading,
    error: getlistError,
    fetchData: gettable,
  } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: token,
    },
  });

  useEffect(() => {
    gettable(`${baseUrl}admin/verticals`);
  }, []);

  // Set the first tab as default once data is fetched
  useEffect(() => {
    if (datalist?.data?.rows?.length > 0 && !activeTab) {
      setActiveTab(datalist.data.rows[0].vertical_id.toString());
      setVisitedTabs(prev => new Set(prev).add(datalist.data.rows[0].vertical_id.toString()));
    }
  }, [datalist]);

  // Handle tab change
  const handleTabChange = (value: string | null) => {
    if (value) {
      setActiveTab(value);
      // Add the new tab to the visited set
      setVisitedTabs(prev => new Set(prev).add(value));
    }
  };

  return (
    <div>
      {getlistError && <p style={{ color: 'red' }}>Error: {getlistError.message}</p>}

      {!listLoading && !getlistError && datalist?.data?.rows?.length > 0 && (
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tabs.List className={classes.tabslst}>
            <Tabs.Tab value={'0'} color="#404040">
              All Sub Categories
            </Tabs.Tab>
            {datalist.data.rows.map((el: any) => (
              <Tabs.Tab key={el.vertical_id} value={el.vertical_id.toString()} color="#404040">
                {el.vertical_name}
              </Tabs.Tab>
            ))}
          </Tabs.List>
          
          {/* Render tab panels that have been visited, but only show the active one */}
          <Tabs.Panel value="0" style={{ display: activeTab === '0' ? 'block' : 'none' }}>
            {visitedTabs.has('0') && (
              <TableCategoryComponent 
                key="tab-0" 
                categoryId={0} 
                editLink={editLink} 
                search={search}
                isActive={activeTab === '0'}
              />
            )}
          </Tabs.Panel>
          
          {datalist.data.rows.map((el: any) => (
            <Tabs.Panel 
              key={el.vertical_id} 
              value={el.vertical_id.toString()}
              style={{ display: activeTab === el.vertical_id.toString() ? 'block' : 'none' }}
            >
              {visitedTabs.has(el.vertical_id.toString()) && (
                <TableCategoryComponent 
                  key={`tab-${el.vertical_id}`}
                  categoryId={el.vertical_id} 
                  editLink={editLink} 
                  search={search}
                  isActive={activeTab === el.vertical_id.toString()}
                />
              )}
            </Tabs.Panel>
          ))}
        </Tabs>
      )}
    </div>
  );
};

export default memo(Categorydatatable);